<template>
	<div class="dlive" @click="close()" :style="'min-height:' + minHeight + 'px'">
		<div id="menu">
			<div class="Shutup" @click="shutup()">全局禁言</div>
			<div class="updateShutup" @click="updateShutup()">禁言半小时</div>
		</div>
		<!--比赛信息-->
		<div class="info-box">
			<div class="info-title">
				<img src="//static.fly2a.com/gqj_tv/image/dianjing/game_lol.png" alt="">
				<span>{{ detail.league_name_zh }} BO{{ detail.bo }}&emsp;{{ detail.start_time }}</span>
			</div>
			<div class="info-content">
				<div class="info-l">
					<img src="//static.fly2a.com/gqj_tv/image/dianjing/win_home.png" alt="" width="33px"
						v-if="detail.state == -1 && detail.away_score < detail.home_score" />
					<span class="home_name">
						{{ detail.home_team_zh }}
					</span>
					<span class="home_logo"><img class="team-logo" :src="detail.home_logo"></span>
				</div>
				<div class="info-c">
					<div class="info-vs" v-if="detail.state == 0 || detail.state == -5">
						VS
					</div>
					<div class="info-small" v-if="detail.state > 0">
						{{ detail.battles && detail.battles.team_stats[0].kill_count != null ? detail.battles.team_stats[0].kill_count : '0' }}
						:
						{{ detail.battles && detail.battles.team_stats[1].kill_count != null ? detail.battles.team_stats[1].kill_count : '0' }}
					</div>
					<div class="info-big" v-if="detail.state > 0">
						（{{ detail.home_score }} : {{ detail.away_score }}）
					</div>
					<div class="info-big-over" v-show="detail.state == -1">
						{{ detail.home_score }} : {{ detail.away_score }}
					</div>
					<div
						:class="detail.state == 0 ? 'info-status info-notstart' : detail.state < 0 ? 'info-status info-haved' : 'info-status'">
						<span class="status">{{ detail.state == 0 ? '未开始' : detail.state < 0 ? '已结束' : state_index[detail.index] }}</span>
								<span class="duration"
									v-if="detail.state > 0 && detail.index > 0 && detail.on_time">{{ durationFn(detail.on_time) }}</span>
					</div>
				</div>
				<div class="info-r">
					<img src="//static.fly2a.com/gqj_tv/image/dianjing/win_away.png" alt="" width="33px"
						v-if="detail.state == -1 && detail.away_score > detail.home_score" />
					<span class="away_logo"><img class="team-logo" :src="detail.away_logo"></span>
					<span class="away_name">
						{{ detail.away_team_zh }}
					</span>
				</div>
			</div>
		</div>
		<div class="banner">
			<img :src="banner.img_url" @click="jumpFn(banner.jump_url)" width="100%" />
		</div>
		<!--视频数据-->
		<div class="live-content" v-if="detail.state != -1 || detail.anchor.length > 0">
			<div class="live-box" @mouseleave="addUrlForm = 0">
				<div class="live-tab">
					<div class="live-tab1">
						<img src="//static.fly2a.com/gqj_tv/image/dianjing/icon_video.png" alt="" />
						<span class="video_title">视频直播</span>
						<span id="showAddUrlBtn" v-show="(memberType == 9 || memberType == 2) && detail.state >= 0"
							@click="showAddUrl">申请开播</span>
						<div class="addUrlForm-outer" v-show="addUrlForm" @click.stop>
							<div id="addUrlForm" class="addUrlForm">
								<span>直播链接:&nbsp;</span>
								<input type="hidden" name="tournament_id" :value="ids">
								<input type="hidden" name="tournament_type" :value="detail.tournament_type">

								<span id="formStr">
								</span>
								<br>
								<a href="javascript:;" @click="submitUrlForm()">提交</a>
							</div>
						</div>
					</div>
					<div class="live-tab2">
						<div class="video-origin" style="display: inline-block;" @click="tabCurrUrl(item)"
							@mouseenter="showCurrUrl(item)" v-for="item in detail.anchor">
							<img :title="item.username" :src="item.face" alt=""
								:class="item.tvid == detail.tvid ? 'pitchOn' : ''">
						</div>
					</div>
				</div>
				<div class="live-left">
					<div class="novideo" v-show="novideo">
						视频已下架，请选其他视频观看！
					</div>
					<iframe id="iframe2" :src="detail.player" width="748" height="420" frameborder="no" scrolling="no"
						allow="autoplay; fullscreen" allowfullscreen v-show="detail.player">
					</iframe>
					<div class="tv_outer" v-if="detail.anchor.length > 1 && !detail.player">
						<div class="tv_title">
							尊上请您选择幸运主播
						</div>
						<div class="tv-list-wrap">
							<div class="tv_select" v-for="item, index in detail.anchor" @click="tabCurrUrl(item)">
								<div class="">
									<img :src="item.face" />
								</div>
								<div class="tv_username">
									{{ item.username }}
								</div>
								<div class="tv_label" v-if="item.label" v-html="handleLabel(item.label)"></div>
							</div>
						</div>
					</div>
					<div v-if="noZhibo" class="swiper-container" id="noZhibo">
						<img src="//static.fly2a.com/static/image/b-live/zhubo-no.png">
					</div>
				</div>
			</div>
			<div class="live-right">
				<div class="char-box">
					<div class="title">
						<span class="chatname">
							<img src="//static.fly2a.com/gqj_tv/image/chats.png" alt=""
								width="16px" />&ensp;<span>{{ detail.username ? detail.username : '' }}</span><span>{{ detail.username ? '的' : '' }}聊天室</span>
						</span>
						<span class="count">
							<img src="//static.fly2a.com/006zhibo/image/eye.png" alt="" width="16px" />
							<span class="text">{{ viewerFn(detail.viewer) }}</span>
						</span>
					</div>
					<div class="msg-list">
						<div>
							<span><i class="iconfont hornicon" style="color: #E84D5D;">&#xe8e8;</i>&ensp;<i class="horn"
									style="color: #666;">据用户反馈，有主播存在违规行为，为维护网络绿色直播环境，现已封停所有主播账号进行整改。</i></span>
						</div>
						<ul id="dialog" class="per-content" style="min-height: 198px;">
						</ul>
					</div>
					<div class="msg-post">
						<textarea class="msg-content" id="textarea"></textarea>
						<div class="say-btn">
							<div class="shield" v-if="shield.show">
								<div @click="shieldFn()">
									<span><i class="iconfont2" v-if="!shield.shieldALL"></i></span>
									<img src="//static.fly2a.com/006zhibo/image/checked.png" alt=""
										v-if="shield.shieldALL" width="16px" />
									<span>屏蔽所有入场消息</span>
								</div>
							</div>
							<img :src="shield.shieldALL || shield.shieldYK ? '//static.fly2a.com/gqj_tv/image/shield2.png' : '//static.fly2a.com/gqj_tv/image/shield1.png'"
								@click="shield.show = !shield.show" width="22px" />
							<i class="iconfont btn btn-default face-btn face pull-left">&#xe656;</i>
							<input type="submit" class="btn btn-default submit-btn" value="发表" id="subBtn"
								@click="onSubmit()" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="live-data">
			<div class="data-tab">
				<span :class="dataTab == 1 ? 'active' : ''" @click="dataTab = 1">实时赛况</span>
				<span :class="dataTab == 2 ? 'active' : ''" @click="dataTab = 2">数据分析</span>
				<span :class="dataTab == 3 ? 'active' : ''" @click="dataTab = 3">百家指数</span>
			</div>
			<div class="nodata" v-if="(battleArr.length == 0 && dataTab == 1) || (!analysis.strength && dataTab == 2)">
				<img src="https://qn.jdj007.com/icon_none2.png-200x200" alt="" />
				<div class="">
					数据更新中，请稍后再试
				</div>
			</div>
			<!--实时赛况-->
			<div class="battle-wrapper" v-show="dataTab == 1" v-if="battleArr.length > 0">
				<!--主客队战绩对比-->
				<div class="battles-data">
					<div class="battles-nav">
						<span :class="currbattle == item ? 'active' : ''" v-for="item in battleArr.length"
							@click="currbattle = item">第{{ battleNum[item] }}局</span>
					</div>
					<div class="battles-team">
						<div class="battles-team-data battles-hometeam">
							<img src="//static.fly2a.com/gqj_tv/image/dianjing/win_home.png" alt="" width="33px"
								v-if="battleArr[currbattle - 1].status && battleArr[currbattle - 1].team_stats[0].is_win" />
							<span class="battles-team-name">
								{{ detail.home_team_zh }}
							</span>
							<span class="battles-team-logo"><img class="team-logo" :src="detail.home_logo"></span>
						</div>
						<div class="battles-time">{{ battlesDurationFn(battleArr[currbattle - 1].duration) }}</div>
						<div class="battles-team-data battles-awayteam">
							<img src="//static.fly2a.com/gqj_tv/image/dianjing/win_away.png" alt="" width="33px"
								v-if="battleArr[currbattle - 1].status && battleArr[currbattle - 1].team_stats[1].is_win" />
							<span class="battles-team-logo"><img class="team-logo" :src="detail.away_logo"></span>
							<span class="battles-team-name">
								{{ detail.away_team_zh }}
							</span>
						</div>
					</div>
					<div class="battles-table">
						<div class="battles-table-l">
							<div class="battles-table-content">
								<div class="battles-table-top">
									<div class="">
										{{ battleArr[currbattle - 1].team_stats[0].tower_success_count }}
									</div>
									<div class="">
										{{ battleArr[currbattle - 1].team_stats[0].small_dragon_count }}
									</div>
									<div class="">
										{{ battleArr[currbattle - 1].team_stats[0].big_dragon_count }}
									</div>
								</div>
								<div class="battles-table-bottom">
									<div class="">
										推塔
									</div>
									<div class="">
										小龙
									</div>
									<div class="">
										大龙
									</div>
								</div>
							</div>
							<div class="battles-achievement">
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[0].is_ten_kills">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/kill_ten.png" alt=""
										title="十杀" />
								</span>
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[0].is_first_big_dragon">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/first_big_loong.png"
										alt="" title="首大龙" />
								</span>
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[0].is_first_small_dragon">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/first_small_loong.png"
										alt="" title="首小龙" />
								</span>
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[0].is_first_tower">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/first_tower.png"
										alt="" title="首塔" />
								</span>
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[0].is_five_kills">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/kill_five.png" alt=""
										title="五杀" />
								</span>
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[0].is_first_blood">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/one_blood.png" alt=""
										title="一血" />
								</span>
							</div>
						</div>
						<div class="battles-table-c">
							<div class="table-score-l">
								{{ battleArr[currbattle - 1].team_stats[0].kill_count }}
							</div>
							<div class="table-score-c">
								<div>:</div>
								<div class="">
									击杀
								</div>
							</div>
							<div class="table-score-r">
								{{ battleArr[currbattle - 1].team_stats[1].kill_count }}
							</div>
						</div>
						<div class="battles-table-r">
							<div class="battles-table-content">
								<div class="battles-table-top">
									<div class="">
										{{ battleArr[currbattle - 1].team_stats[1].tower_success_count }}
									</div>
									<div class="">
										{{ battleArr[currbattle - 1].team_stats[1].small_dragon_count }}
									</div>
									<div class="">
										{{ battleArr[currbattle - 1].team_stats[1].big_dragon_count }}
									</div>
								</div>
								<div class="battles-table-bottom">
									<div class="">
										推塔
									</div>
									<div class="">
										小龙
									</div>
									<div class="">
										大龙
									</div>
								</div>
							</div>
							<div class="battles-achievement">
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[1].is_first_blood">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/one_blood.png" alt=""
										title="一血" />
								</span>
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[1].is_five_kills">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/kill_five.png" alt=""
										title="五杀" />
								</span>
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[1].is_first_tower">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/first_tower.png"
										alt="" title="首塔" />
								</span>
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[1].is_first_small_dragon">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/first_small_loong.png"
										alt="" title="首小龙" />
								</span>
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[1].is_first_big_dragon">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/first_big_loong.png"
										alt="" title="首大龙" />
								</span>
								<span class="name" v-if="battleArr[currbattle - 1].team_stats[1].is_ten_kills">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/live/kill_ten.png" alt=""
										title="十杀" />
								</span>
							</div>
						</div>
					</div>
					<div class="battles-money">
						<div class="battles-money-l">
							<div class="">
								{{ moneyFn(battleArr[currbattle - 1].team_stats, 1) }}
								{{ moneyFn(battleArr[currbattle - 1].team_stats[0].money) }}K
							</div>
							<div class="bar">
								<div class="bar-box-r"
									:style="'width:' + (battleArr[currbattle - 1].team_stats[0].money / (battleArr[currbattle - 1].team_stats[0].money + battleArr[currbattle - 1].team_stats[1].money) * 100) + '%;'">
								</div>
							</div>
						</div>
						<div class="battles-money-c">经济</div>
						<div class="battles-money-r">
							<div class="">
								{{ moneyFn(battleArr[currbattle - 1].team_stats, 2) }}
								{{ moneyFn(battleArr[currbattle - 1].team_stats[1].money) }}K
							</div>
							<div class="bar">
								<div class="bar-box-l"
									:style="'width:' + (battleArr[currbattle - 1].team_stats[1].money / (battleArr[currbattle - 1].team_stats[0].money + battleArr[currbattle - 1].team_stats[1].money) * 100) + '%;'">
								</div>
							</div>
						</div>
					</div>
					<div class="battles-egame">
						<div class="battles-pick">
							<img :src="item.avatar" :title="item.name"
								v-for="item in battleArr[currbattle - 1].pick_hero[detail.home_team_id]" />
							<span>PICK</span>
							<img :src="item.avatar" :title="item.name"
								v-for="item in battleArr[currbattle - 1].pick_hero[detail.away_team_id]" />
						</div>
						<div class="battles-ban">
							<img :src="item.avatar" :title="item.name"
								v-for="item in battleArr[currbattle - 1].ban_hero[detail.home_team_id]" />
							<span>BAN</span>
							<img :src="item.avatar" :title="item.name"
								v-for="item in battleArr[currbattle - 1].ban_hero[detail.away_team_id]" />
						</div>
					</div>
				</div>
				<!--球员信息-->
				<div class="team-player">
					<!--主队-->
					<div class="player-tab">
						<div class="tab-head">
							<div class="side"
								:style="battleArr[currbattle - 1].team_stats[0].side ? 'background: url(https://static.fly2a.com/gqj_tv/image/dianjing/live/red.png);' : 'background: url(https://static.fly2a.com/gqj_tv/image/dianjing/live/blue.png);'">
								<span>{{ battleArr[currbattle - 1].team_stats[0].side ? '红方' : '蓝方' }}</span>&ensp;
								<span class="name">{{ detail.home_team_zh }}</span>
							</div>
							<div class="equipment"></div>
							<div class="KDA">K / D / A</div>
							<div class="offered">参团率</div>
							<div class="output">输出</div>
							<div class="damage">承伤</div>
							<div class="rost">补刀</div>
							<div class="economics">经济</div>
						</div>
						<div class="tab-body" v-for="item in battleArr[currbattle - 1].player_stats[detail.home_team_id]">
							<div class="side">
								<img :src="item.hero_avatar" :title="item.hero_name" alt="" />
								<span>{{ item.player_name }}</span>
							</div>
							<div class="equipment">
								<span>技能</span>
								<img :src="item.prop[propI] ? item.prop[propI] : 'https://static.fly2a.com/gqj_tv/image/dianjing/icon_lol_shadow.png'"
									alt="" v-for="propI in 7" />
							</div>
							<div class="KDA">
								<div>{{ item.kda }}</div>
								<div>{{ item.kill_count }} / {{ item.death_count }} / {{ item.assist_count }}</div>
							</div>
							<div class="offered">
								{{ item.offered_rate }}%
							</div>
							<div class="output">
								<div>{{ item.damage_count }}</div>
								<div>占比{{ item.damage_percent }}%</div>
							</div>
							<div class="damage">
								<div>{{ item.damage_taken_count }}</div>
								<div>占比{{ item.damage_taken_percent }}%</div>
							</div>
							<div class="rost">
								<div>{{ item.last_hit_count }}</div>
								<div>{{ item.last_hit_minute }}/分</div>
							</div>
							<div class="economics">
								<div>{{ moneyFn(item.money_count) }}K</div>
								<div>{{ moneyFn(item.money_minute) }}K/分</div>
							</div>
						</div>
					</div>
					<!--客队-->
					<div class="player-tab">
						<div class="tab-head">
							<div class="side"
								:style="battleArr[currbattle - 1].team_stats[1].side ? 'background: url(https://static.fly2a.com/gqj_tv/image/dianjing/live/red.png);' : 'background: url(https://static.fly2a.com/gqj_tv/image/dianjing/live/blue.png);'">
								<span>{{ battleArr[currbattle - 1].team_stats[1].side ? '红方' : '蓝方' }}</span>&ensp;
								<span class="name">{{ detail.away_team_zh }}</span>
							</div>
							<div class="equipment"></div>
							<div class="KDA">K / D / A</div>
							<div class="offered">参团率</div>
							<div class="output">输出</div>
							<div class="damage">承伤</div>
							<div class="rost">补刀</div>
							<div class="economics">经济</div>
						</div>
						<div class="tab-body" v-for="item in battleArr[currbattle - 1].player_stats[detail.away_team_id]">
							<div class="side">
								<img :src="item.hero_avatar" :title="item.hero_name" alt="" />
								<span>{{ item.player_name }}</span>
							</div>
							<div class="equipment">
								<span>技能</span>
								<img :src="item.prop[propI] ? item.prop[propI] : 'https://static.fly2a.com/gqj_tv/image/dianjing/icon_lol_shadow.png'"
									alt="" v-for="propI in 7" />
							</div>
							<div class="KDA">
								<div>{{ item.kda }}</div>
								<div>{{ item.kill_count }} / {{ item.death_count }} / {{ item.assist_count }}</div>
							</div>
							<div class="offered">
								{{ item.offered_rate }}%
							</div>
							<div class="output">
								<div>{{ item.damage_count }}</div>
								<div>占比{{ item.damage_percent }}%</div>
							</div>
							<div class="damage">
								<div>{{ item.damage_taken_count }}</div>
								<div>占比{{ item.damage_taken_percent }}%</div>
							</div>
							<div class="rost">
								<div>{{ item.last_hit_count }}</div>
								<div>{{ item.last_hit_minute }}/分</div>
							</div>
							<div class="economics">
								<div>{{ moneyFn(item.money_count) }}K</div>
								<div>{{ moneyFn(item.money_minute) }}K/分</div>
							</div>
						</div>
					</div>
				</div>
				<!--经济差，经验差折线图-->
				<div class="battles-echarts">
					<echarts></echarts>
				</div>
			</div>
			<!--数据分析-->
			<div class="battle-wrapper" v-show="dataTab == 2">
				<div class="team-analysis" v-if="analysis.strength">
					<div class="analysis-title">
						<div>
							<img src="https://static.fly2a.com/gqj_tv/image/dianjing/team-analysis.png"
								alt="" /><span>战队分析</span>
						</div>
					</div>
					<div class="analysis-content">
						<div class="analysis-l">
							<div class="analysis-team">
								<span>{{ detail.home_team_zh }}</span>
								<img :src="detail.home_logo" alt="" />
							</div>
							<div class="analysis-KDA">
								<span
									class="KDA">{{ analysis.strength.average_kda_team_a }}</span><span>{{ analysis.strength.average_kills_team_a }}
									/ {{ analysis.strength.average_deaths_team_a }} /
									{{ analysis.strength.average_assists_team_a }}</span>
							</div>
							<div class="analysis-circle">
								<div class="circle">
									<div class="circle-out">
										<div class="circle-l">
											<div :style="rotateZFn(analysis.strength.first_tower_kill_team_a, 1)"></div>
										</div>
										<div class="circle-r">
											<div :style="rotateZFn(analysis.strength.first_tower_kill_team_a)"></div>
										</div>
										<div class="circle-num">
											{{ analysis.strength.first_tower_kill_team_a }}%
										</div>
									</div>
									<div class="circle-title">
										一塔率
									</div>
								</div>
								<div class="circle">
									<div class="circle-out">
										<div class="circle-l">
											<div :style="rotateZFn(analysis.strength.first_blood_kill_team_a, 1)"></div>
										</div>
										<div class="circle-r">
											<div :style="rotateZFn(analysis.strength.first_blood_kill_team_a)"></div>
										</div>
										<div class="circle-num">
											{{ analysis.strength.first_blood_kill_team_a }}%
										</div>
									</div>
									<div class="circle-title">
										一血率
									</div>
								</div>
								<div class="circle">
									<div class="circle-out">
										<div class="circle-l">
											<div :style="rotateZFn(analysis.strength.victory_rate_a, 1)"></div>
										</div>
										<div class="circle-r">
											<div :style="rotateZFn(analysis.strength.victory_rate_a)"></div>
										</div>
										<div class="circle-num">
											{{ analysis.strength.victory_rate_a }}%
										</div>
									</div>
									<div class="circle-title">
										胜率
									</div>
								</div>
								<div class="circle">
									<div class="circle-out">
										<div class="circle-l">
											<div :style="rotateZFn(analysis.strength.rate_baron_team_a, 1)"></div>
										</div>
										<div class="circle-r">
											<div :style="rotateZFn(analysis.strength.rate_baron_team_a)"></div>
										</div>
										<div class="circle-num">
											{{ analysis.strength.rate_baron_team_a }}%
										</div>
									</div>
									<div class="circle-title">
										大龙控制率
									</div>
								</div>
								<div class="circle">
									<div class="circle-out">
										<div class="circle-l">
											<div :style="rotateZFn(analysis.strength.rate_dragon_team_a, 1)"></div>
										</div>
										<div class="circle-r">
											<div :style="rotateZFn(analysis.strength.rate_dragon_team_a)"></div>
										</div>
										<div class="circle-num">
											{{ analysis.strength.rate_dragon_team_a }}%
										</div>
									</div>
									<div class="circle-title">
										小龙控制率
									</div>
								</div>
							</div>
						</div>
						<div class="analysis-c">
							<div class="Slogan">
								近6场
							</div>
							<div class="progress-title">
								<span
									class="fl">{{ analysis.strength.hand_win_team_a }}胜{{ analysis.strength.hand_lose_team_a }}负</span>
								<span>交锋战绩</span>
								<span
									class="fr">{{ analysis.strength.hand_win_team_b }}胜{{ analysis.strength.hand_lose_team_b }}负</span>
							</div>
							<div class="progress-out">
								<div class="progress">
									<div class="progress-bar-l"
										:style="'width: ' + (analysis.strength.hand_win_team_a / 6 * 100) + '%;'"></div>
								</div>
								<div class="progress">
									<div class="progress-bar-r"
										:style="'width: ' + (analysis.strength.hand_win_team_b / 6 * 100) + '%;'"></div>
								</div>
							</div>
							<div class="progress-title">
								<span
									class="fl">{{ analysis.strength.record_win_team_a }}胜{{ analysis.strength.record_lose_team_a }}负</span>
								<span>近期战绩</span>
								<span
									class="fr">{{ analysis.strength.record_win_team_b }}胜{{ analysis.strength.record_lose_team_b }}负</span>
							</div>
							<div class="progress-out">
								<div class="progress">
									<div class="progress-bar-l"
										:style="'width: ' + (analysis.strength.record_win_team_a / (analysis.strength.record_win_team_a + analysis.strength.record_lose_team_a) * 100) + '%;'">
									</div>
								</div>
								<div class="progress">
									<div class="progress-bar-r"
										:style="'width: ' + (analysis.strength.record_win_team_b / (analysis.strength.record_win_team_b + analysis.strength.record_lose_team_b) * 100) + '%;'">
									</div>
								</div>
							</div>
							<div class="progress-title">
								<span class="fl">{{ moneyFn(analysis.strength.average_money_team_a) }}K</span>
								<span>场均经济</span>
								<span class="fr">{{ moneyFn(analysis.strength.average_money_team_b) }}K</span>
							</div>
							<div class="progress-out">
								<div class="progress">
									<div class="progress-bar-l"
										:style="'width: ' + (analysis.strength.average_money_team_a / (analysis.strength.average_money_team_a + analysis.strength.average_money_team_b) * 100) + '%;'">
									</div>
								</div>
								<div class="progress">
									<div class="progress-bar-r"
										:style="'width: ' + (analysis.strength.average_money_team_b / (analysis.strength.average_money_team_a + analysis.strength.average_money_team_b) * 100) + '%;'">
									</div>
								</div>
							</div>
							<div class="progress-title">
								<span class="fl">{{ analysis.strength.average_kills_team_a }}</span>
								<span>场均击杀</span>
								<span class="fr">{{ analysis.strength.average_kills_team_b }}</span>
							</div>
							<div class="progress-out">
								<div class="progress">
									<div class="progress-bar-l"
										:style="'width: ' + (analysis.strength.average_kills_team_a / (analysis.strength.average_kills_team_a + analysis.strength.average_kills_team_b) * 100) + '%;'">
									</div>
								</div>
								<div class="progress">
									<div class="progress-bar-r"
										:style="'width: ' + (analysis.strength.average_kills_team_b / (analysis.strength.average_kills_team_a + analysis.strength.average_kills_team_b) * 100) + '%;'">
									</div>
								</div>
							</div>
							<div class="progress-title">
								<span class="fl">{{ analysis.strength.average_dragon_team_a }}</span>
								<span>场均小龙</span>
								<span class="fr">{{ analysis.strength.average_dragon_team_b }}</span>
							</div>
							<div class="progress-out">
								<div class="progress">
									<div class="progress-bar-l"
										:style="'width: ' + (analysis.strength.average_dragon_team_a / (analysis.strength.average_dragon_team_a + analysis.strength.average_dragon_team_b) * 100) + '%;'">
									</div>
								</div>
								<div class="progress">
									<div class="progress-bar-r"
										:style="'width: ' + (analysis.strength.average_dragon_team_b / (analysis.strength.average_dragon_team_a + analysis.strength.average_dragon_team_b) * 100) + '%;'">
									</div>
								</div>
							</div>
							<div class="progress-title">
								<span class="fl">{{ analysis.strength.average_baron_team_a }}</span>
								<span>场均大龙</span>
								<span class="fr">{{ analysis.strength.average_baron_team_b }}</span>
							</div>
							<div class="progress-out">
								<div class="progress">
									<div class="progress-bar-l"
										:style="'width: ' + (analysis.strength.average_baron_team_a / (analysis.strength.average_baron_team_a + analysis.strength.average_baron_team_b) * 100) + '%;'">
									</div>
								</div>
								<div class="progress">
									<div class="progress-bar-r"
										:style="'width: ' + (analysis.strength.average_baron_team_b / (analysis.strength.average_baron_team_a + analysis.strength.average_baron_team_b) * 100) + '%;'">
									</div>
								</div>
							</div>
							<div class="progress-title">
								<span class="fl">{{ analysis.strength.average_tower_team_a }}</span>
								<span>场均拆塔</span>
								<span class="fr">{{ analysis.strength.average_tower_team_b }}</span>
							</div>
							<div class="progress-out">
								<div class="progress">
									<div class="progress-bar-l"
										:style="'width: ' + (analysis.strength.average_tower_team_a / (analysis.strength.average_tower_team_a + analysis.strength.average_tower_team_b) * 100) + '%;'">
									</div>
								</div>
								<div class="progress">
									<div class="progress-bar-r"
										:style="'width: ' + (analysis.strength.average_tower_team_b / (analysis.strength.average_tower_team_a + analysis.strength.average_tower_team_b) * 100) + '%;'">
									</div>
								</div>
							</div>
							<div class="progress-title">
								<span class="fl">{{ battlesDurationFn(analysis.strength.average_time_a) }}</span>
								<span>场均游戏时长</span>
								<span class="fr">{{ battlesDurationFn(analysis.strength.average_time_b) }}</span>
							</div>
							<div class="progress-out">
								<div class="progress">
									<div class="progress-bar-l"
										:style="'width: ' + (analysis.strength.average_time_a / (analysis.strength.average_time_a + analysis.strength.average_time_b) * 100) + '%;'">
									</div>
								</div>
								<div class="progress">
									<div class="progress-bar-r"
										:style="'width: ' + (analysis.strength.average_time_b / (analysis.strength.average_time_a + analysis.strength.average_time_b) * 100) + '%;'">
									</div>
								</div>
							</div>
						</div>
						<div class="analysis-r">
							<div class="analysis-team">
								<span>{{ detail.away_team_zh }}</span>
								<img :src="detail.away_logo" alt="" />
							</div>
							<div class="analysis-KDA">
								<span>{{ analysis.strength.average_kills_team_b }} /
									{{ analysis.strength.average_deaths_team_b }} /
									{{ analysis.strength.average_assists_team_b }}</span><span
									class="KDA">{{ analysis.strength.average_kda_team_b }}</span>
							</div>
							<div class="analysis-circle">
								<div class="circle">
									<div class="circle-out">
										<div class="circle-l">
											<div :style="rotateZFn(analysis.strength.victory_rate_b, 1)"></div>
										</div>
										<div class="circle-r">
											<div :style="rotateZFn(analysis.strength.victory_rate_b)"></div>
										</div>
										<div class="circle-num">
											{{ analysis.strength.victory_rate_b }}%
										</div>
									</div>
									<div class="circle-title">
										胜率
									</div>
								</div>
								<div class="circle">
									<div class="circle-out">
										<div class="circle-l">
											<div :style="rotateZFn(analysis.strength.first_blood_kill_team_b, 1)"></div>
										</div>
										<div class="circle-r">
											<div :style="rotateZFn(analysis.strength.first_blood_kill_team_b)"></div>
										</div>
										<div class="circle-num">
											{{ analysis.strength.first_blood_kill_team_b }}%
										</div>
									</div>
									<div class="circle-title">
										一血率
									</div>
								</div>
								<div class="circle">
									<div class="circle-out">
										<div class="circle-l">
											<div :style="rotateZFn(analysis.strength.first_tower_kill_team_b, 1)"></div>
										</div>
										<div class="circle-r">
											<div :style="rotateZFn(analysis.strength.first_tower_kill_team_b)"></div>
										</div>
										<div class="circle-num">
											{{ analysis.strength.first_tower_kill_team_b }}%
										</div>
									</div>
									<div class="circle-title">
										一塔率
									</div>
								</div>
								<div class="circle">
									<div class="circle-out">
										<div class="circle-l">
											<div :style="rotateZFn(analysis.strength.rate_dragon_team_b, 1)"></div>
										</div>
										<div class="circle-r">
											<div :style="rotateZFn(analysis.strength.rate_dragon_team_b)"></div>
										</div>
										<div class="circle-num">
											{{ analysis.strength.rate_dragon_team_b }}%
										</div>
									</div>
									<div class="circle-title">
										小龙控制率
									</div>
								</div>
								<div class="circle">
									<div class="circle-out">
										<div class="circle-l">
											<div :style="rotateZFn(analysis.strength.rate_baron_team_b, 1)"></div>
										</div>
										<div class="circle-r">
											<div :style="rotateZFn(analysis.strength.rate_baron_team_b)"></div>
										</div>
										<div class="circle-num">
											{{ analysis.strength.rate_baron_team_b }}%
										</div>
									</div>
									<div class="circle-title">
										大龙控制率
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="player-analysis" v-if="analysis.prospect">
					<div class="analysis-title">
						<div>
							<img src="https://static.fly2a.com/gqj_tv/image/dianjing/player-analysis.png"
								alt="" /><span>选手分析</span>
						</div>
						<div class="player-analysis-tab">
							<div :class="currprospect == key ? 'active' : ''" v-for="item, key in analysis.prospect"
								@click="currprospect = key; currhomeplayer = 0; currawayplayer = 0">{{ prospectName[key] }}</div>
						</div>
					</div>
					<div class="player-data"
						v-if="player_home = analysis.prospect[currprospect][detail.home_team_id][currhomeplayer]">
						<div class="player-l">
							<div class="player-out">
								<div class="player-more">
									<img :src="item.player.avatar" :title="item.nickname" width="30px" height="30px"
										@click="currhomeplayer = index" v-if="currhomeplayer != index"
										v-for="item, index in analysis.prospect[currprospect][detail.home_team_id]" />
								</div>
								<div class="player-face">
									<div class="appearance-num">
										（出场{{ player_home.present_matches }}次）
									</div>
									<img :src="player_home.player.avatar" width="76px" height="76px" />
								</div>
								<div class="player-name">
									{{ player_home.nickname }}
								</div>
								<div class="analysis-KDA">
									<span class="KDA">{{ player_home.kda }}</span> <span>{{ player_home.kill_average }} /
										{{ player_home.death_average }} / {{ player_home.assist_average }}</span>
								</div>
							</div>
							<div class="player-progress"
								v-if="player_away = analysis.prospect[currprospect][detail.away_team_id][currawayplayer]">
								<div class="progress-title">
									<span class="fl">{{ player_home.victory_rate }}%</span>
									<span>胜率</span>
									<span class="fr">{{ player_away.victory_rate }}%</span>
								</div>
								<div class="progress-out">
									<div class="progress">
										<div class="progress-bar-l"
											:style="'width: ' + (player_home.victory_rate / (player_home.victory_rate + player_away.victory_rate) * 100) + '%;'">
										</div>
									</div>
									<div class="progress">
										<div class="progress-bar-r"
											:style="'width: ' + (player_away.victory_rate / (player_home.victory_rate + player_away.victory_rate) * 100) + '%;'">
										</div>
									</div>
								</div>
								<div class="progress-title">
									<span class="fl">{{ player_home.team_percent }}%</span>
									<span>参团率</span>
									<span class="fr">{{ player_away.team_percent }}%</span>
								</div>
								<div class="progress-out">
									<div class="progress">
										<div class="progress-bar-l"
											:style="'width: ' + (player_home.team_percent / (player_home.team_percent + player_away.team_percent) * 100) + '%;'">
										</div>
									</div>
									<div class="progress">
										<div class="progress-bar-r"
											:style="'width: ' + (player_away.team_percent / (player_home.team_percent + player_away.team_percent) * 100) + '%;'">
										</div>
									</div>
								</div>
								<div class="progress-title">
									<span class="fl">{{ player_home.damage_deal_percent }}%</span>
									<span>伤害转换率</span>
									<span class="fr">{{ player_away.damage_deal_percent }}%</span>
								</div>
								<div class="progress-out">
									<div class="progress">
										<div class="progress-bar-l"
											:style="'width: ' + (player_home.damage_deal_percent / (player_home.damage_deal_percent + player_away.damage_deal_percent) * 100) + '%;'">
										</div>
									</div>
									<div class="progress">
										<div class="progress-bar-r"
											:style="'width: ' + (player_away.damage_deal_percent / (player_home.damage_deal_percent + player_away.damage_deal_percent) * 100) + '%;'">
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="player-r">
							<div class="player-out">
								<div class="player-more">
									<img :src="item.player.avatar" :title="item.nickname" width="30px" height="30px"
										@click="currawayplayer = index" v-if="currawayplayer != index"
										v-for="item, index in analysis.prospect[currprospect][detail.away_team_id]" />
								</div>
								<div class="player-face">
									<div class="appearance-num">
										（出场{{ player_away.present_matches }}次）
									</div>
									<img :src="player_away.player.avatar" width="76px" height="76px" />
								</div>
								<div class="player-name">
									{{ player_away.nickname }}
								</div>
								<div class="analysis-KDA">
									<span>{{ player_away.kill_average }} / {{ player_away.death_average }} /
										{{ player_away.assist_average }}</span> <span
										class="KDA">{{ player_away.kda }}</span>
								</div>
							</div>
							<div class="player-progress">
								<div class="progress-title">
									<span class="fl">{{ player_home.minute_damage_dealt }}</span>
									<span>每分钟伤害</span>
									<span class="fr">{{ player_away.minute_damage_dealt }}</span>
								</div>
								<div class="progress-out">
									<div class="progress">
										<div class="progress-bar-l"
											:style="'width: ' + (player_home.minute_damage_dealt / (player_home.minute_damage_dealt + player_away.minute_damage_dealt) * 100) + '%;'">
										</div>
									</div>
									<div class="progress">
										<div class="progress-bar-r"
											:style="'width: ' + (player_away.minute_damage_dealt / (player_home.minute_damage_dealt + player_away.minute_damage_dealt) * 100) + '%;'">
										</div>
									</div>
								</div>
								<div class="progress-title">
									<span class="fl">{{ moneyFn(player_home.minute_economic) }}K</span>
									<span>每分钟经济</span>
									<span class="fr">{{ moneyFn(player_away.minute_economic) }}K</span>
								</div>
								<div class="progress-out">
									<div class="progress">
										<div class="progress-bar-l"
											:style="'width: ' + (player_home.minute_economic / (player_home.minute_economic + player_away.minute_economic) * 100) + '%;'">
										</div>
									</div>
									<div class="progress">
										<div class="progress-bar-r"
											:style="'width: ' + (player_away.minute_economic / (player_home.minute_economic + player_away.minute_economic) * 100) + '%;'">
										</div>
									</div>
								</div>
								<div class="progress-title">
									<span class="fl">{{ player_home.minute_wards_placed }}</span>
									<span>每分钟插眼</span>
									<span class="fr">{{ player_away.minute_wards_placed }}</span>
								</div>
								<div class="progress-out">
									<div class="progress">
										<div class="progress-bar-l"
											:style="'width: ' + (player_home.minute_wards_placed / (player_home.minute_wards_placed + player_away.minute_wards_placed) * 100) + '%;'">
										</div>
									</div>
									<div class="progress">
										<div class="progress-bar-r"
											:style="'width: ' + (player_away.minute_wards_placed / (player_home.minute_wards_placed + player_away.minute_wards_placed) * 100) + '%;'">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="engagement-analysis" v-if="analysis.records">
					<div class="analysis-title">
						<div>
							<img src="https://static.fly2a.com/gqj_tv/image/dianjing/engagement.png"
								alt="" /><span>交战记录</span>
						</div>
						<!--<div class="iconfont2">
							&#xe630;
						</div>-->
					</div>
					<div class="engagement-table">
						<div class="engagement-tr" v-for="item in analysis.records">
							<div class="engagement-th1">
								{{ item.start_time }}
							</div>
							<div class="engagement-th2">
								{{ item.league_name_zh }}
							</div>
							<div class="engagement-th3">
								BO{{ item.bo }}
							</div>
							<div class="engagement-th4">
								<img src="https://static.fly2a.com/gqj_tv/image/dianjing/win.png"
									v-if="item.home_score > item.away_score" alt="" class="win"
									width="15px" /><span>{{ item.home_team_zh }}</span><img :src="item.home_logo" alt=""
									class="logo" width="28px" height="28px" />
							</div>
							<div class="engagement-th5">
								<span>{{ item.home_score ? item.home_score : "0" }}</span>
								:
								<span>{{ item.away_score ? item.away_score : "0" }}</span>
							</div>
							<div class="engagement-th6">
								<img :src="item.away_logo" alt="" class="logo" width="28px"
									height="28px" /><span>{{ item.away_team_zh }}</span><img
									src="https://static.fly2a.com/gqj_tv/image/dianjing/win.png"
									v-if="item.home_score < item.away_score" alt="" class="win" width="15px" />
							</div>
							<div class="engagement-th7">
								详情
							</div>
						</div>
					</div>
				</div>
				<div class="achievements-analysis" v-if="analysis.near">
					<div class="analysis-title">
						<div>
							<img src="https://static.fly2a.com/gqj_tv/image/dianjing/achievements.png"
								alt="" /><span>近期战绩</span>
						</div>
						<!--<div class="iconfont2">
							&#xe630;
						</div>-->
					</div>
					<div class="achievements-table">
						<div class="achievements-table-l">
							<div class="achievements-l-team">
								<img class="logo" :src="detail.home_logo">
								<span class="name">
									{{ detail.home_team_zh }}
								</span>
							</div>
							<div class="achievements-tr" v-for="item in analysis.near.home">
								<div class="achievements-th1">
									<div>{{ item.league_name_zh }}</div>
									<div>{{ item.start_time }}</div>
								</div>
								<div class="achievements-th2">
									BO{{ item.bo }}
								</div>
								<div class="achievements-th3">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/win.png"
										v-if="item.home_score > item.away_score" alt="" class="win"
										width="15px" /><span>{{ item.home_team_zh }}</span><img :src="item.home_logo"
										alt="" class="logo" width="28px" height="28px" />
								</div>
								<div class="achievements-th4">
									<span>{{ item.home_score }}</span>
									:
									<span>{{ item.away_score }}</span>
								</div>
								<div class="achievements-th5">
									<img :src="item.away_logo" alt="" class="logo" width="28px"
										height="28px" /><span>{{ item.away_team_zh }}</span><img
										src="https://static.fly2a.com/gqj_tv/image/dianjing/win.png"
										v-if="item.home_score < item.away_score" alt="" class="win" width="15px" />
								</div>
							</div>
						</div>
						<div class="achievements-table-r">
							<div class="achievements-r-team">
								<span class="name">
									{{ detail.away_team_zh }}
								</span>
								<img class="logo" :src="detail.away_logo">
							</div>
							<div class="achievements-tr" v-for="item in analysis.near.away">
								<div class="achievements-th1">
									<div>{{ item.league_name_zh }}</div>
									<div>{{ item.start_time }}</div>
								</div>
								<div class="achievements-th2">
									BO{{ item.bo }}
								</div>
								<div class="achievements-th3">
									<img src="https://static.fly2a.com/gqj_tv/image/dianjing/win.png"
										v-if="item.home_score > item.away_score" alt="" class="win"
										width="15px" /><span>{{ item.home_team_zh }}</span><img :src="item.home_logo"
										alt="" class="logo" width="28px" height="28px" />
								</div>
								<div class="achievements-th4">
									<span>{{ item.home_score }}</span>
									:
									<span>{{ item.away_score }}</span>
								</div>
								<div class="achievements-th5">
									<img :src="item.away_logo" alt="" class="logo" width="28px"
										height="28px" /><span>{{ item.away_team_zh }}</span><img
										src="https://static.fly2a.com/gqj_tv/image/dianjing/win.png"
										v-if="item.home_score < item.away_score" alt="" class="win" width="15px" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--百家指数-->
			<div class="battle-wrapper battle-odds" v-show="dataTab == 3">
				<div class="odds-tab">
					<span>全场</span><span class="active">第一局</span><span>第二局</span><span>第三局</span><span>第四局</span>
				</div>
				<div class="odds-title">
					第二局 - 胜负
				</div>
				<div class="odds-table">
					<table border="0" cellspacing="0" cellpadding="0">
						<tr>
							<th class="odds-th1">公司</th>
							<th class="odds-th2">{{ detail.home_team_zh }}</th>
							<th class="odds-th3">{{ detail.away_team_zh }}</th>
							<th class="odds-th4">{{ detail.home_team_zh }}胜率</th>
							<th class="odds-th5">{{ detail.away_team_zh }}胜率</th>
							<th class="odds-th6">返还率</th>
						</tr>
						<tr>
							<td class="odds-th1">anggame</td>
							<td class="odds-th2">1.45</td>
							<td class="odds-th3">2.65</td>
							<td class="odds-th4">64.63%</td>
							<td class="odds-th5">35.38%</td>
							<td class="odds-th6">93.72</td>
						</tr>
						<tr>
							<td class="odds-th1">anggame</td>
							<td class="odds-th2">1.45</td>
							<td class="odds-th3">2.65</td>
							<td class="odds-th4">64.63%</td>
							<td class="odds-th5">35.38%</td>
							<td class="odds-th6">93.72</td>
						</tr>
						<tr>
							<td class="odds-th1">anggame</td>
							<td class="odds-th2">1.45</td>
							<td class="odds-th3">2.65</td>
							<td class="odds-th4">64.63%</td>
							<td class="odds-th5">35.38%</td>
							<td class="odds-th6">93.72</td>
						</tr>
					</table>
				</div>
				<div class="odds-title">
					第二局 - 让分胜负
				</div>
				<div class="odds-table">
					<table border="0" cellspacing="0" cellpadding="0">
						<tr>
							<th class="odds-th1">公司</th>
							<th class="odds-th2">{{ detail.home_team_zh }}(-1.5)</th>
							<th class="odds-th3">{{ detail.away_team_zh }}(+1.5)</th>
							<th class="odds-th4">{{ detail.home_team_zh }}胜率</th>
							<th class="odds-th5">{{ detail.away_team_zh }}胜率</th>
							<th class="odds-th6">返还率</th>
						</tr>
						<tr>
							<td class="odds-th1">anggame</td>
							<td class="odds-th2">1.45</td>
							<td class="odds-th3">2.65</td>
							<td class="odds-th4">64.63%</td>
							<td class="odds-th5">35.38%</td>
							<td class="odds-th6">93.72</td>
						</tr>
						<tr>
							<td class="odds-th1">anggame</td>
							<td class="odds-th2">1.45</td>
							<td class="odds-th3">2.65</td>
							<td class="odds-th4">64.63%</td>
							<td class="odds-th5">35.38%</td>
							<td class="odds-th6">93.72</td>
						</tr>
						<tr>
							<td class="odds-th1">anggame</td>
							<td class="odds-th2">1.45</td>
							<td class="odds-th3">2.65</td>
							<td class="odds-th4">64.63%</td>
							<td class="odds-th5">35.38%</td>
							<td class="odds-th6">93.72</td>
						</tr>
					</table>
				</div>
				<div class="odds-title">
					第二局 - 击杀大小
				</div>
				<div class="odds-table">
					<table border="0" cellspacing="0" cellpadding="0">
						<tr>
							<th class="odds-th1">公司</th>
							<th class="odds-th2">大于(22.5)</th>
							<th class="odds-th3">小于(22.5)</th>
							<th class="odds-th4">大分率</th>
							<th class="odds-th5">小分率</th>
							<th class="odds-th6">返还率</th>
						</tr>
						<tr>
							<td class="odds-th1">anggame</td>
							<td class="odds-th2">1.45</td>
							<td class="odds-th3">2.65</td>
							<td class="odds-th4">64.63%</td>
							<td class="odds-th5">35.38%</td>
							<td class="odds-th6">93.72</td>
						</tr>
						<tr>
							<td class="odds-th1">anggame</td>
							<td class="odds-th2">1.45</td>
							<td class="odds-th3">2.65</td>
							<td class="odds-th4">64.63%</td>
							<td class="odds-th5">35.38%</td>
							<td class="odds-th6">93.72</td>
						</tr>
						<tr>
							<td class="odds-th1">anggame</td>
							<td class="odds-th2">1.45</td>
							<td class="odds-th3">2.65</td>
							<td class="odds-th4">64.63%</td>
							<td class="odds-th5">35.38%</td>
							<td class="odds-th6">93.72</td>
						</tr>
					</table>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import axios from "axios";
import { onChatroomConnect, onCanConnect, onChatroomDisconnect, onSubmit, markChatroomGaglist, updateChatroomMemberTempMute, scrollToLocation } from "@/assets/js/chatroom.js";
import echarts from "../components/echarts";
export default {
	data() {
		return {
			minHeight: '',
			ids: this.$route.query.tournament_id,
			type: this.$route.query.type,
			tvid: this.$route.query.tvid,
			headCon: headCon(),
			banner: {
				jump_url: "#",
				img_url: "//static.fly2a.com/gqj_tv/banner.png"
			},
			memberType: 0,
			novideo: 0,
			dataTab: 1,
			detail: {
				anchor: [],
				username: "",
				player: "",
				tvid: "",
				roomid: "",
				viewer: "",
				state: -1,
				battles: {
					index: 0,
					duration: 0,
					team_stats: [{
						side: null,
						assist_count: null,
						big_dragon_count: null,
						death_count: null,
						is_first_big_dragon: null,
						is_first_blood: null,
						is_first_small_dragon: null,
						is_first_tower: null,
						is_five_kills: null,
						is_ten_kills: null,
						is_win: null,
						kill_count: null,
						money: null,
						small_dragon_count: null,
						tower_success_count: null
					}, {
						side: null,
						assist_count: null,
						big_dragon_count: null,
						death_count: null,
						is_first_big_dragon: null,
						is_first_blood: null,
						is_first_small_dragon: null,
						is_first_tower: null,
						is_five_kills: null,
						is_ten_kills: null,
						is_win: null,
						kill_count: null,
						money: null,
						small_dragon_count: null,
						tower_success_count: null
					}]
				}
			},
			battleArr: [],
			battleNum: {
				1: "一",
				2: "二",
				3: "三",
				4: "四",
				5: "五",
				6: "六"
			},
			currbattle: 1,
			analysis: {},
			prospectName: {
				"adc": "ADC",
				"ap": "中单",
				"jungle": "打野",
				"support": "辅助",
				"top": "上单"
			},
			currprospect: "top",
			currhomeplayer: 0,
			currawayplayer: 0,
			player_home: {},
			player_away: {},
			shield: {
				shieldYK: false,
				shieldALL: false,
				show: false
			},
			state_index: ["进行中", "第一局", "第二局", "第三局", "第四局", "第五局", "第六局", "第七局", "第八局"],
			tv_pitch_On: "",
			addUrlForm: 0,
			noZhibo: 0
		}
	},
	components: {
		echarts
	},
	created() {
		this.getDetail();
		this.getBattle();
		this.getAnalysis();
		this.getZhibo();
	},
	beforeMount() {
		var wx_login_t = this.$route.query.wx_login_t;
		if (wx_login_t) {
			var href = location.href;
			if (location.href.indexOf("&") == -1) {
				href = href.replace("?wx_login_t=" + wx_login_t, "");
			} else {
				href = href.replace("&wx_login_t=" + wx_login_t, "");
				href = href.replace("wx_login_t=" + wx_login_t + "&", "");
			}
			history.pushState("", "", href);
		}
	},
	mounted() {
		if (this.getCookie("type")) {
			this.memberType = this.getCookie("type");
		}
		var shield = window.localStorage.getItem("shield");
		if (shield == 1) {
			this.shield.shieldALL = true;
		}
		this.liveMain();
		this.chat_click();
		this.minHeight = $(window).height() - 110;
		$('.haed_dianjing').addClass('nuxt-link-exact-active');
		$("footer").show();
	},
	methods: {
		rotateZFn(num, type) {
			var deg = 0;
			if (num > 50) {
				deg = (num - 50) / 50 * 180 + 225;
				if (type) {
					return "transform: rotateZ(" + deg + "deg);"
				} else {
					return "transform: rotateZ(45deg);"
				}
			} else {
				deg = num / 50 * 180 - 135;
				if (type) {
					return ""
				} else {
					return "transform: rotateZ(" + deg + "deg);"
				}
			}
		},
		getDetail() {
			var url = COMMOND.NEW_BASE_URL + "get_esport_detail/?id=" + this.ids + "&type=" + this.type
			axios.get(url)
				.then((res) => {
					res = res.data;
					var data = res.data;
					if (data.anchor.length == 1) {
						data.player = COMMOND.VIDEO_URL + data.anchor[0].tvid;
						data.tvid = data.anchor[0].tvid;
						data.roomid = data.anchor[0].roomid;
						data.username = data.anchor[0].username;
						data.viewer = data.anchor[0].viewer;
						if (data.roomid) {
							this.createdChatroom(data.roomid)
						}
					} else if (this.tvid) {
						for (var i = 0; i < data.anchor.length; i++) {
							if (this.tvid == data.anchor[i].tvid) {
								data.player = COMMOND.VIDEO_URL + data.anchor[i].tvid;
								data.tvid = data.anchor[i].tvid;
								data.roomid = data.anchor[i].roomid;
								data.username = data.anchor[i].username;
								data.viewer = data.anchor[i].viewer;
								if (data.roomid) {
									this.createdChatroom(data.roomid)
								}
								break
							}
							if (i == data.anchor.length - 1) {
								data.player = COMMOND.VIDEO_URL + data.anchor[0].tvid;
								data.tvid = data.anchor[0].tvid;
								data.roomid = data.anchor[0].roomid;
								data.username = data.anchor[0].username;
								data.viewer = data.anchor[0].viewer;
								if (data.roomid) {
									this.createdChatroom(data.roomid)
								}
							}
						}
					} else {
						data.player = "";
						data.tvid = "";
						data.roomid = "";
						data.username = "公共";
						data.viewer = 0;
						if (data.public_roomid && data.state != -1) {
							this.createdChatroom(data.public_roomid)
						}
					}
					data.battles = this.battlesFn(data.battles, data.home_team_id)
					this.detail = data;
					if (this.detail.anchor.length == 0) {
						this.noZhibo = 1;
					}
				})
		},
		battlesFn(battles, id) {
			if (battles.length == 0) {
				battles = {
					index: 0,
					duration: 0,
					team_stats: []
				};
			} else {
				battles = battles[battles.length - 1];
			}
			if (battles.status) {
				battles.index = 0;
				battles.duration = 0;
			}
			if (battles.team_stats.length == 2) {
				if (battles.team_stats[0].team_id == id) {
					return battles
				} else {
					battles.team_stats[0] = battles.team_stats.splice(1, 1, battles.team_stats[0])[0];
					return battles
				}
			} else {
				battles.team_stats = [{
					side: null,
					assist_count: null,
					big_dragon_count: null,
					death_count: null,
					is_first_big_dragon: null,
					is_first_blood: null,
					is_first_small_dragon: null,
					is_first_tower: null,
					is_five_kills: null,
					is_ten_kills: null,
					is_win: null,
					kill_count: null,
					money: null,
					small_dragon_count: null,
					tower_success_count: null
				}, {
					side: null,
					assist_count: null,
					big_dragon_count: null,
					death_count: null,
					is_first_big_dragon: null,
					is_first_blood: null,
					is_first_small_dragon: null,
					is_first_tower: null,
					is_five_kills: null,
					is_ten_kills: null,
					is_win: null,
					kill_count: null,
					money: null,
					small_dragon_count: null,
					tower_success_count: null
				}]
				return battles
			}
		},
		durationFn(num) {
			return Math.floor(num / 60)
		},
		moneyFn(team, type) {
			if (type == 2) {
				if (team[0].money < team[1].money) {
					var num = (parseFloat((team[1].money / 1000).toFixed(1)) - parseFloat((team[0].money / 1000).toFixed(1))).toFixed(1);
					num = num.replace(".0", "");
					return '(领先' + num + 'K)'
				} else {
					return ''
				}
			} else if (type == 1) {
				if (team[0].money > team[1].money) {
					var num = (parseFloat((team[0].money / 1000).toFixed(1)) - parseFloat((team[1].money / 1000).toFixed(1))).toFixed(1);
					num = num.replace(".0", "");
					return '(领先' + num + 'K)'
				} else {
					return ''
				}
			} else {
				var num = (team / 1000).toFixed(1);
				num = num.replace(".0", "");
				return num
			}
		},
		battlesDurationFn(num) {
			var m = Math.floor(num / 60);
			var s = num % 60;
			return m + "'" + s + "''"
		},
		getBattle() {
			var url = COMMOND.NEW_BASE_URL + "get_esport_detail_battle/?id=" + this.ids + "&type=" + this.type
			axios.get(url)
				.then((res) => {
					res = res.data;
					var data = res.data;
					if (data.length > 0) {
						for (var i = 0; i < data.length; i++) {
							data[i] = this.team_stats(data[i], this.detail.home_team_id)
						}
						console.log(data)
						this.battleArr = data;
						console.log(this.battleArr[this.currbattle - 1].team_stats[0].kill_count)
					}
				})
		},
		team_stats(battles, id) {
			if (battles.team_stats.length == 2) {
				if (battles.team_stats[0].team_id == id) {
					return battles
				} else {
					battles.team_stats[0] = battles.team_stats.splice(1, 1, battles.team_stats[0])[0];
					return battles
				}
			} else {
				battles.team_stats = [{
					side: null,
					assist_count: null,
					big_dragon_count: null,
					death_count: null,
					is_first_big_dragon: null,
					is_first_blood: null,
					is_first_small_dragon: null,
					is_first_tower: null,
					is_five_kills: null,
					is_ten_kills: null,
					is_win: null,
					kill_count: null,
					money: null,
					small_dragon_count: null,
					tower_success_count: null
				}, {
					side: null,
					assist_count: null,
					big_dragon_count: null,
					death_count: null,
					is_first_big_dragon: null,
					is_first_blood: null,
					is_first_small_dragon: null,
					is_first_tower: null,
					is_five_kills: null,
					is_ten_kills: null,
					is_win: null,
					kill_count: null,
					money: null,
					small_dragon_count: null,
					tower_success_count: null
				}]
				return battles
			}
		},
		getAnalysis() {
			var url = COMMOND.NEW_BASE_URL + "get_esport_analysis/?id=" + this.ids + "&type=" + this.type
			axios.get(url)
				.then((res) => {
					res = res.data;
					var data = res.data;
					this.analysis = data;
					console.log(data)
				})
		},
		getZhibo() {
			var that = this;
			var token = that.getCookie('token');
			if (!token) {
				return
			}
			var member_id = that.getCookie('member_id');
			if (!member_id) {
				member_id = '';
			}
			$.ajax({
				type: "GET",
				dataType: "json",
				headers: {
					"Authorization": token
				},
				url: COMMOND.NEW_BASE_URL + "getzhibo",
				success: function (res) {
					$(".move-ad").attr("data-btn", res.data.showAddBtn)
					if (res.data.showAddBtn == 1) {
						//								console.log(res.data.member.type);
						if (that.memberType == 9) {
							$('.move-ad').css("height", "20%");
						}
						$('#showAddUrlBtn').attr('style', '');
						$('#formStr').html(res.data.formStr);
						$('#formStr #currMember').after("<br/>")
						$("#formStr #url").on("keydown", function (e) {
							if (e.keyCode === 13 && !e.ctrlKey) { // 按enter键提交
								that.submitUrlForm()
							}
						});
					} else {
						$('.move-ad').css("height", "0");
					}
				}
			});
		},
		handleLabel(label, index) {
			return label.replace(",", "<br>").replace("，", "<br>")
		},
		shutup() {
			$("#menu").hide();
			var keys = $("#menu").attr("keys");
			axios.post(COMMOND.NEW_BASE_URL + 'mute', {
				uid: keys.replace(COMMOND.DEV, "")
			}, {
				headers: {
					'Authorization': this.getCookie("token")
				}
			})
				.then((res) => {
					if (res.data.code == 200) {
						layer.msg("全局禁言成功");
					} else {
						layer.msg(res.data.msg);
					}
				})

		},
		updateShutup() {
			$("#menu").hide();
			var keys = $("#menu").attr("keys");
			updateChatroomMemberTempMute(keys, true);
		},
		close() {
			$("#menu").hide();
		},
		createdChatroom(chatroomid) {
			if (!this.getCookie("yk_token") && !this.getCookie("netease_im_token")) {
				this.getykmsg(chatroomid);
				return
			}
			this.chatroomid = chatroomid;
			var netease_im_token = this.getCookie("netease_im_token") ? this.getCookie("netease_im_token") : this.getCookie("yk_token");
			this.netease_im_token = this.getCookie("netease_im_token");
			sessionStorage.setItem("chatroomid", chatroomid);
			var member_id = this.getCookie("member_id") ? COMMOND.DEV + this.getCookie("member_id") : this.getCookie("yk_account");
			onChatroomConnect(member_id, netease_im_token, chatroomid, this.getykmsg);
		},
		getykmsg(chatroomid) {
			if (!this.getCookie("netease_im_token")) {
				axios.get(COMMOND.NEW_BASE_URL + 'get_visitor')
					.then((res) => {
						//			    		console.log(res)
						var data = res.data.data;
						this.setCookie("yk_name", data.nick_name);
						this.setCookie("yk_account", data.accid);
						this.setCookie("yk_token", data.token);
						this.createdChatroom(chatroomid);
					})
			}
		},
		jumpFn(jump_url) {
			if (jump_url && jump_url != "#") {
				window.open(jump_url)
			}
		},
		viewerFn(viewer) {
			if (viewer > 10000) {
				return (viewer / 10000).toFixed(2) + "万"
			} else {
				return viewer
			}
		},
		shieldFn() {
			if (this.shield.shieldALL) {
				window.localStorage.setItem("shield", 0);
			} else {
				window.localStorage.setItem("shield", 1);
			}
			this.shield.shieldALL = !this.shield.shieldALL;
			this.shield.show = false;
			this.$nextTick(function () {
				scrollToLocation();
			})
		},
		onSubmit() {
			if (!this.netease_im_token || this.netease_im_token == 1) {
				if (!this.netease_im_token) {
					$(".loading").show();
					$(".loading_content1").show();
					$(".zhuce").show();
					$(".loading_content2").hide();
					$(".authimg").attr("src", COMMOND.NEW_BASE_URL + "get_img_code?" + Math.random() * 10000);
				} else {
					layer.tips('暂无聊天室', $("#textarea"), {
						tips: [4, '#e24949'],
						time: 3000
					});
				}
				return;
			}
			onSubmit();
		},
		chat_click() {
			var that = this;
			$('.face').click(function (event) {
				$(this).sinaEmotion($("textarea"));
				event.stopPropagation();
			});
			// 回车发送
			$("#textarea").on("keydown", function (e) {
				if (e.keyCode === 13 && !e.ctrlKey) { // 按enter键提交
					var nowTime = new Date().getTime();
					var clickTime = $(this).attr("ctime");
					if (clickTime != 'undefined' && (nowTime - clickTime < 3000)) { //禁止连续发言
						layer.tips('客官,说话太快啦(つД`)', this, {
							tips: [4, '#e24949'],
							time: 3000
						});
					} else {
						e.preventDefault();
						$('#subBtn').click();
						$(this).attr("ctime", nowTime);
					}
				}

				// 按ctrl+enter组合键换行
				if (e.keyCode === 13 && e.ctrlKey) {
					$(this).val(function (i, val) {
						return val + "\n";
					});
				}
			});
		},
		setCookie(name, value) {
			document.cookie = name + "=" + value + ";path=/";
		},
		getCookie(name) {
			var arr = document.cookie.split("; ");
			for (var i = 0; i < arr.length; i++) {
				var arr2 = arr[i].split("=");
				if (arr2[0] == name) {
					return arr2[1];
				}
			}
			return "";
		},
		showCurrUrl(item) { // 鼠标经过头像
			if (this.memberType == 2 || this.memberType == 9) {
				var url = item.url;
				var str = item.username;
				$('#member_id').val(item.member_id)
				if (item.member_id == this.getCookie('member_id') || this.memberType == 9) {
					$('#member_id').css({
						'display': 'inline-block'
					});
					$("#addUrlForm a").css("display", "block");
					$('#currMember').html('');
				} else {
					$('#currMember').html(str);
					$('#member_id').css({
						'display': 'none'
					});
					$("#addUrlForm a").css("display", "none");
				}
				$("#tvid").val(item.tvid);
				$('#formStr input[name="url"]').val(url);
				this.addUrlForm = 1;
			}
		},
		tabCurrUrl(item) {
			if (this.detail.tvid == item.tvid) {
				return
			}
			if (!onCanConnect()) {
				layer.msg("切换太快啦，请慢点切换！");
				return
			}
			this.detail.player = COMMOND.VIDEO_URL + item.tvid;
			this.detail.tvid = item.tvid;
			this.detail.roomid = item.roomid;
			this.detail.username = item.username;
			this.detail.viewer = item.viewer;
			if (this.detail.roomid) {
				this.createdChatroom(this.detail.roomid);
			}
			this.addUrlForm = 0
		},
		showAddUrl(el) { // 弹出增加窗口
			if (this.detail.anchor.length >= 5) {
				alert("开播人数已满，不可再申请开播！");
				return
			}
			if (!this.addUrlForm) {
				var member_id = this.getCookie('member_id')
				if (this.memberType == 2) {
					for (var i = 0; i < this.detail.anchor.length; i++) {
						if (member_id == this.detail.anchor[i].member_id) {
							alert("已开播，不可重复开播！");
							return
						}
					}
				}
				$('#member_id').val(member_id)
				this.addUrlForm = 1;
				$('#member_id').css({
					'display': ''
				});
				$('#currMember').html('');
				$("#addUrlForm a").css("display", "block");
				if ($('#issuper').val() > 0) {
					$('#tvid').val('');
					$('#url').val('');
				}
			} else {
				this.addUrlForm = 0;
			}
		},
		submitUrlForm() { // 提交
			if ($('#member_id').val() == this.getCookie('member_id') || this.memberType == 9) {
				var that = this;
				this.addUrlForm = 0;
				var getcookie = that.getCookie('token');
				var data = "tournament_id=" + $("input[name='tournament_id']").val() + "&tournament_type=" + that.detail.tournament_type + "&url=" + $("input[name='url']").val() + "&tvid=" + $("input[name='tvid']").val() + "&member_id=" + $('#member_id').val() + "&sort=1"
				if (data.indexOf("member_id") == -1) {
					data = data + '&member_id=' + $('#member_id').val()
				}
				if (data.indexOf("zbsort") != -1) {
					data = data.replace("zbsort", "sort")
				}
				$.ajax({
					type: "Get",
					dataType: "json",
					headers: {
						'Authorization': getcookie
					},
					url: COMMOND.NEW_BASE_URL + "add_url?" + data,
					success: function (res) {
						if (res.code == 200) {
							window.location.reload();
						} else {
							alert(res.msg);
						}
					}
				});
			} else {
				alert("无权限上传此链接");
			}
		},
		getTime(oDate) {
			var date = new Date(oDate)
			var year = date.getFullYear(); //获取完整的年份(4位,1970-????)
			var month = date.getMonth() + 1 >= 10 ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1)); //获取当前月份(0-11,0代表1月)
			var day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate(); //获取当前日(1-31)
			var h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
			var im = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
			return "" + year + "-" + month + "-" + day + " " + h + ":" + im;
		},
		liveMain() {
			var that = this;
			var lockReconnect = false;//避免重复连接
			var wsUrl = COMMOND.NEW_SOCKET_URL;
			//	          	var wsUrl = "ws://ws.guangqiujie.com/";
			var ws;
			var tt;
			function createWebSocket() {
				try {
					ws = new WebSocket(wsUrl);
					init();
				} catch (e) {
					reconnect(wsUrl);
				}
			}
			function init() {
				ws.onclose = function () {
					// console.log('链接关闭');
					reconnect(wsUrl);
				};
				ws.onerror = function () {
					// console.log('发生异常了');
					reconnect(wsUrl);
				};
				ws.onopen = function () {
					ws.send('{"type":"init","task_id":"ematches_' + that.ids + '"}');
					//心跳检测重置
					heartCheck.start();
				};
				ws.onmessage = function (res) {//拿到任何消息都说明当前连接是正常的
					//console.log('接收到消息');
					res = JSON.parse(res.data);
					heartCheck.start();
					if (!res.result) {
						return
					}
					if (res.type == "matches") {
						if (res.result.state) {
							that.detail.state = res.result.state;
						}
						if (res.result.start_time_int) {
							that.detail.start_time = that.getTime(res.result.start_time_int * 1000);
						}
						if (res.result.away_score) {
							that.detail.away_score = res.result.away_score;
						}
						if (res.result.home_score) {
							that.detail.home_score = res.result.home_score;
						}
					} else if (res.type == "battle") {
						if (res.result.duration) {
							that.detail.on_time = res.result.duration;
						}
						if (res.result.index) {
							that.detail.index = res.result.index;
						}
						if (res.result.status != undefined) {
							if (res.result.status) {
								that.detail.index = 0;
								that.detail.on_time = 0;
							}
						}
					} else if (res.type == "team") {
						var team_index = 0;
						if (res.result.team_id == that.detail.away_team_id) {
							team_index = 1
						}
						if (res.result.assist_count != undefined) {
							that.detail.battles.team_stats[team_index].assist_count = res.result.assist_count
						}
						if (res.result.big_dragon_count != undefined) {
							that.detail.battles.team_stats[team_index].big_dragon_count = res.result.big_dragon_count
						}
						if (res.result.death_count != undefined) {
							that.detail.battles.team_stats[team_index].death_count = res.result.death_count
						}
						if (res.result.is_first_big_dragon != undefined) {
							that.detail.battles.team_stats[team_index].is_first_big_dragon = res.result.is_first_big_dragon
						}
						if (res.result.is_first_blood != undefined) {
							that.detail.battles.team_stats[team_index].is_first_blood = res.result.is_first_blood
						}
						if (res.result.is_first_small_dragon != undefined) {
							that.detail.battles.team_stats[team_index].is_first_small_dragon = res.result.is_first_small_dragon
						}
						if (res.result.is_first_tower != undefined) {
							that.detail.battles.team_stats[team_index].is_first_tower = res.result.is_first_tower
						}
						if (res.result.is_five_kills != undefined) {
							that.detail.battles.team_stats[team_index].is_five_kills = res.result.is_five_kills
						}
						if (res.result.is_ten_kills != undefined) {
							that.detail.battles.team_stats[team_index].is_ten_kills = res.result.is_ten_kills
						}
						if (res.result.is_win != undefined) {
							that.detail.battles.team_stats[team_index].is_win = res.result.is_win
						}
						if (res.result.kill_count != undefined) {
							that.detail.battles.team_stats[team_index].kill_count = res.result.kill_count
						}
						if (res.result.money != undefined) {
							that.detail.battles.team_stats[team_index].money = res.result.money
						}
						if (res.result.side != undefined) {
							that.detail.battles.team_stats[team_index].side = res.result.side
						}
						if (res.result.small_dragon_count != undefined) {
							that.detail.battles.team_stats[team_index].small_dragon_count = res.result.small_dragon_count
						}
						if (res.result.tower_success_count != undefined) {
							that.detail.battles.team_stats[team_index].tower_success_count = res.result.tower_success_count
						}
					}
				}
			}
			function reconnect(url) {
				if (lockReconnect) {
					return;
				};
				lockReconnect = true;
				//没连接上会一直重连，设置延迟避免请求过多
				tt && clearTimeout(tt);
				tt = setTimeout(function () {
					createWebSocket(url);
					lockReconnect = false;
				}, 4000);
			}
			//心跳检测
			var heartCheck = {
				timeout: 30000,
				timeoutObj: null,
				serverTimeoutObj: null,
				start: function () {
					// console.log('start');
					var self = this;
					this.timeoutObj && clearTimeout(this.timeoutObj);
					this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
					this.timeoutObj = setTimeout(function () {
						//这里发送一个心跳，后端收到后，返回一个心跳消息，
						ws.send('{"type":"init","task_id":"ematches_' + that.ids + '"}');
						self.serverTimeoutObj = setTimeout(function () {
							ws.close();
							// createWebSocket();
						}, self.timeout);

					}, this.timeout)
				}
			}
			if (!lockReconnect) {
				createWebSocket(wsUrl);
			}
		}
	},
	metaInfo() {
		return {
			title: this.headCon["dianjing"]["title"],
			script: [{
				src: '/static/js/f-chat.js'
			}, {
				src: '//static.fly2a.com/static/lib/chat/js/swfobject.js'
			},
			{
				src: '//static.fly2a.com/static/lib/chat/js/web_socket.js'
			},
			{
				src: '//static.fly2a.com/static/lib/chat/js/jquery-sinaEmotion-2.1.0.js'
			} //聊天长连接

			],
			link: [{
				rel: 'stylesheet',
				href: '//static.fly2a.com/static/lib/chat/css/jquery-sinaEmotion-2.1.0.min.css'
			},
			{
				rel: 'stylesheet',
				href: '//static.fly2a.com/static/lib/chat/css/style.css'
			}
			],
			meta: [{
				hid: "description",
				name: "description",
				content: this.headCon["dianjing"]["description"]
			},
			{
				hid: "keywords",
				name: 'keywords',
				content: this.headCon["dianjing"]["keywords"]
			},
			]
		}
	}
}
</script>

<style>
@import "../../assets/css/d-live.css";
</style>